<template>
  <transition name="fade">
    <div class="row mt-5" :class="{ 'restore-padding': isBlockView }">
      <div class="col-md-12 list-view mb-2">
        <div class="card pl_m mb-2">
          <div class="card-body py-2">
            <div class="pl_m--t"></div>
          </div>
        </div>
      </div>

      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
      <search-placeholder :isBlockView="isBlockView" />
    </div>
  </transition>
</template>

<script>
import SearchPlaceholder from '@/components/search/Placeholder'

export default {
  name: 'searchPlaceholders',
  components: {
    SearchPlaceholder
  },
  props: {
    isBlockView: {
      type: Boolean,
      required: true
    }
  }
}
</script>
